import "core-js/modules/esnext.iterator.constructor.js";
import "core-js/modules/esnext.iterator.filter.js";
function D(t, o, m, b, l) {
  let i, s;
  if (!t || !o)
    return {
      pos: "center",
      corner: void 0
    };
  const f = 14, r = 2, d = t.top + t.height / 2, v = t.left + t.width / 2, e = {
    top: t.top - o.height - f,
    bottom: b - t.bottom - o.height - f,
    left: t.left - o.width - f,
    right: m - t.right - o.width - f
  }, n = {
    left: v - o.width / 2 - r <= 0,
    right: v + o.width / 2 + r >= m,
    top: d - o.height / 2 - r <= 0,
    bottom: d + o.height / 2 + r >= b
  }, w = {
    top: "bottom",
    bottom: "top",
    left: "right",
    right: "left"
  }[l], a = Object.keys(e).filter((h) => e[h] > 0), j = Object.keys(e).sort((h, c) => e[h] > e[c] ? -1 : e[h] < e[c] ? 1 : 0);
  return e[l] > 0 ? i = l : e[w] > 0 ? i = w : a.length ? [i] = a : [i] = j, i === "bottom" || i === "top" ? n.left ? s = "left" : n.right && (s = "right") : n.top ? s = "top" : n.bottom && (s = "bottom"), {
    pos: i,
    corner: s
  };
}
export {
  D as default
};
